import React from "react";
import { SubscriptionActionFooter } from "./SubscriptionActionDialog";
import {
  Alert,
  Box,
  Button,
  CircularProgress,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import { PaymentsOutlined } from "@mui/icons-material";
import Note from "../../library/Note";

export default function SubscriptionOfflinePaymentAction({
  sub,
  offlineReferenceNo,
  setOfflineReferenceNo,
  offlineNotes,
  setOfflineNotes,
  offlineReason,
  setOfflineReason,
  submitSettleOfflinePayment,
  updating,
}) {
  if (sub?.status === "cancelled" || sub?.renewal === false) {
    return (
      <Alert severity='warning' sx={{ borderRadius: 2 }}>
        Offline payment recording is unavailable while this subscription is
        cancelled or automatic renewal is off.
      </Alert>
    );
  }

  const isSubmitDisabled =
    updating || !offlineReferenceNo.trim() || !offlineReason.trim();

  return (
    <Stack spacing={2.5}>
      <Note title='Record a payment already received'>
        <Typography variant='body2' color='text.secondary'>
          Marks all unpaid charges in the next bill as paid.
        </Typography>
      </Note>

      <Stack spacing={1}>
        <Typography
          component='label'
          htmlFor='offline-payment-reference'
          variant='body2'
          fontWeight={600}
        >
          Reference no.
        </Typography>
        <TextField
          id='offline-payment-reference'
          size='small'
          fullWidth
          required
          placeholder='Bank transfer or cheque reference'
          helperText='Required to identify the payment.'
          value={offlineReferenceNo}
          onChange={(event) => setOfflineReferenceNo(event.target.value)}
        />
      </Stack>

      <Stack spacing={1}>
        <Typography
          component='label'
          htmlFor='offline-payment-reason'
          variant='body2'
          fontWeight={600}
        >
          Reason
        </Typography>
        <TextField
          id='offline-payment-reason'
          size='small'
          fullWidth
          required
          placeholder='Why is this payment being recorded manually?'
          helperText='Required for the payment record.'
          value={offlineReason}
          onChange={(event) => setOfflineReason(event.target.value)}
        />
      </Stack>

      <Stack spacing={1}>
        <Typography
          component='label'
          htmlFor='offline-payment-notes'
          variant='body2'
          fontWeight={600}
        >
          Notes{" "}
          <Box
            component='span'
            sx={{ color: "text.secondary", fontWeight: 400 }}
          >
            (optional)
          </Box>
        </Typography>
        <TextField
          id='offline-payment-notes'
          size='small'
          fullWidth
          multiline
          minRows={2}
          placeholder='Any additional payment details'
          value={offlineNotes}
          onChange={(event) => setOfflineNotes(event.target.value)}
        />
      </Stack>

      <SubscriptionActionFooter>
        <Button
          variant='contained'
          disableElevation
          onClick={submitSettleOfflinePayment}
          disabled={isSubmitDisabled}
          startIcon={
            updating ? (
              <CircularProgress size={16} color='inherit' />
            ) : (
              <PaymentsOutlined fontSize='small' />
            )
          }
          sx={{ px: 2.5 }}
        >
          {updating ? "Recording..." : "Confirm payment received"}
        </Button>
      </SubscriptionActionFooter>
    </Stack>
  );
}
